import { useEffect } from 'react';

type KeyFilter = (key: string) => boolean;

const useKeyStroke = (
    keyDefine: Array<string> | string | ((e: KeyboardEvent) => void),
    handler?: (e: KeyboardEvent) => void,
): void => {
    let callback: (e: KeyboardEvent) => void;
    const keyFilter: KeyFilter = (key: string) =>
        Array.isArray(keyDefine) ? keyDefine.includes(key) : key === keyDefine;

    if (typeof keyDefine === 'function') {
        callback = keyDefine;
    } else {
        callback = handler!;
    }

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (keyFilter(e.key)) {
                callback(e);
            }
        };
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [keyDefine, callback]);
};

export default useKeyStroke;
